import { NotificationService } from 'src/app/shared/services/notification.service';
import { Module } from './../../../follow-ups/models/deviation';
import {
  inject,
  Component,
  ViewChild,
  OnInit,
  ViewContainerRef,
  ComponentRef
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  FormControl,
  Validators
} from '@angular/forms';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { InputNumber } from 'primeng/inputnumber';
import {
  acceptBothDecimalSeparators,
  parseTemperatureValue,
  isTemperatureControlFeature
} from 'src/app/_helpers/temperature.helper';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

import { UploaderConfig } from './../../../../shared/ecpl-document-explorer/uploader-config';
import { Topic } from '../../../safety-job-analysis/models/topic';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { DeviationServices } from '../../services/deviation.service';
import { HelperService } from './../../../../_services/helper.service';
import { BaseServices } from './../../../kuba.services';

import { Options } from './../../../../_models/options';
import {
  DeviationAttachmentRequest,
  DeviationShared,
  UpdateDeviationRequestDto
} from '../../models/';
import { Auditlogdata } from '../../../safety-job-analysis/models/safetyLog';
import { deviationCaseType } from './../../models/deviationCaseType';
import { Rights, Status } from 'src/app/_models';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Department } from './../../models/deviationDepartment';
import { BusinessDepartmentService } from 'src/app/kuba/business-department.services';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { EmployeeServices } from 'src/app/kuba/employees/services/employee.services';
import { AddDeviationComponent } from 'src/app/kuba/follow-ups/components';
import { DateService } from 'src/app/_services/date.service';

import { jsPDF } from '../../../../shared/browser-jspdf';

@Component({
  selector: 'editDeviation',
  templateUrl: 'deviation-edit.component.html',
  styleUrls: ['deviation-edit.component.scss'],
  standalone: false
})
export class EditDeviationComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  time: any;
  CreatedBy: any;
  CreatedOn: any;
  deviationId: number;
  public PageTitle: any;
  // "Module - Object name" shown read-only below Status when managing a deviation (#5749)
  moduleObjectDisplay = '';
  projectId: number;
  editTypes: any = [];
  topicList: any = [];
  caseId: number;
  topicId: number;
  deviationList: any;
  deviationEditForm: FormGroup | any;
  caseForm: FormGroup;
  isDepartmentAllocated = false;
  TopicForm: FormGroup;
  isHideFS = true;
  // Food safety and Kuba Control deviations have an optional temperature, editable from both the module and follow-up
  hasTemperature = false;
  deviationLog: Auditlogdata[];
  deviationlist: DeviationShared[];
  isCaseDialog = false;
  isAddTopic = false;
  topics: SelectItem[];
  departments: SelectItem[];
  importances: SelectItem[];
  cases: SelectItem[];
  executions: SelectItem[];
  followUps: SelectItem[];
  followUpNotify: any;
  selectedFollowup: string;
  pdf: any;
  selectedCaseType = new deviationCaseType();
  selectedTopic = new Topic();
  console: Options;
  parentKey: any;
  parentId: any;
  departmentList: any[];
  data: any;
  options = [
    new Options(8, 'OPEN'),
    new Options(9, 'DONE'),
    new Options(10, 'REJECTED')
  ];
  hidingElement = false;
  viewTopic = false;
  viewDashboard = false;
  isLabelDisabled: Boolean;
  isTopicalertDisabled: Boolean;
  upConfig: UploaderConfig;
  uploadedFiles: any = [];
  additionalData: any;
  newDocumentAdded: any = [];
  isShowDeviation = true;
  canShowDeviation: boolean;
  followup: any;
  loading = false;
  AddTopicLoading = false;
  manualListItems: SelectItem[];
  isShowManualList = false;
  manualID = 0;
  deviationFeatureKey = 0;
  isFollowup = false;
  parentPath: string;
  loadingReport = false;
  deviationNumberPrefix: string;
  deviationNumber: number;
  featureManualChecklistId: number;
  appManualChecklistId: number;
  activityId: number;
  createdOnForSave: string;
  createdByForSave: number;
  FeatureId: number;
  isGuestHideButton = true;
  topicLabel: any;
  departmentsLabel: any;
  caseLabel: any;
  importanceLabel: any;
  execLabel: any;
  followLabel: any;
  featureId: number;
  featureKey: number;
  followUpAssignedUsers: any[];
  disableSaveButton = false;
  executionId: number;
  followUpId: number;
  currentDeadLine: Date;
  currentDate: Date;
  dateDiff: number;
  featureCompleteChecklistId = 0;
  BusinessId: number;
  IsClear = false;
  isShowNotification = true;
  isExistCaseText: string;
  isFoodSafety = false;
  isShowOnlyEditors: boolean;
  Reference: boolean;
  department = false;
  selectedDepartment = new Department();
  departmentForm: FormGroup;
  private subscriptions: Subscription[] = [];
  NotifyMyDeviationsChange: boolean;
  showDeviationLog: boolean;
  IsSubDepartmentHidden = true;
  subDepartmentsList: SelectItem[];
  editSubDepartments: SelectItem[];
  @ViewChild('addSubDeptViewRef', { read: ViewContainerRef })
  addSubDeptModalContainer!: ViewContainerRef;
  addSubDeptComponentRef: ComponentRef<AddDeviationComponent> | null = null;
  minDate!: Date;
  // Portal-level properties
  isPortal: boolean = false;
  portalBusinessId: number | null = null;
  portalBusinessName: string | null = null;

  /**
   * Get the effective business ID for the current context
   * For portal users, use the portal business ID, otherwise use BaseServices.BusinessId
   */
  get effectiveBusinessId(): number {
    return this.isPortal && this.portalBusinessId
      ? this.portalBusinessId
      : BaseServices.BusinessId;
  }

  //#endregion

  isDepartmentErrorDisabled: boolean;
  deptId: number;
  formDeviation: FormGroup;
  Department: SelectItem[];
  departmentdetails: Department[];
  hidesElement = false;
  //#endregion

  //#region constructor
  /**
   * constructor
   * @param router {Router}
   * @param route {ActivatedRoute}
   * @param deviationService {DeviationServices}
   * @param formBuilder {FormBuilder}
   * @param location {Location}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private route: ActivatedRoute,
    private deviationService: DeviationServices,
    private formBuilder: FormBuilder,
    private location: Location,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private businessDepartmentService: BusinessDepartmentService,
    private datePipe: DatePipe,
    private employeeServices: EmployeeServices,
    private dateService: DateService
  ) {
    if (+BaseServices.roleId === 4) {
      this.isGuestHideButton = false;
    }
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (+BaseServices.roleId === 5) {
      this.isGuestHideButton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    }

    this.parentId = route.snapshot.parent.parent.params['id'];
    this.parentKey = this.route.snapshot.parent.parent.data['parent'];
    if (this.parentKey == 'FS' || this.parentKey == 'KC')
      this.isFoodSafety = true;
    this.initForm();
    this.routePath();

    if (this.parentKey == 'FS' || this.parentKey == 'KC') {
      this.isShowOnlyEditors = false;
    } else {
      this.isShowOnlyEditors = true;
    }
  }

  /**
   * editing deviation and binding deviation data
   */
  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');
    this.isShowDeviation = BaseServices.roleId === '2' ? false : true;
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    // Check if this is a portal user and get business ID from query parameters
    this.isPortal = BaseServices.roleId === '2';
    if (this.isPortal) {
      this.route.queryParams.subscribe((queryParams: Params) => {
        if (queryParams['Id']) {
          this.portalBusinessId = +queryParams['Id'];
        }
        if (queryParams['Name']) {
          this.portalBusinessName = queryParams['Name'];
        }
      });
    }

    this.caseForm = this.formBuilder.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.departmentForm = this.formBuilder.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.TopicForm = this.formBuilder.group({
      Topic: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ]
    });
    this.route.parent.params.subscribe((params: Params) => {
      let pId = +params['id'];
      this.projectId = +pId;
    });
    this.bindFormDropdowns();
    this.console = this.options.filter(item => item.id === 1)[0];
    this.subscriptions.push(
      this.route.params.subscribe((params: Params) => {
        this.deviationId = +params['deviationId'];
        this.additionalData = {
          ApplicationId: BaseServices.ApplicationId,
          BusinessId: this.effectiveBusinessId,
          Status: '1',
          CreatedOn: new Date(),
          ModifiedBy: BaseServices.UserId,
          ModifiedOn: new Date(),
          ParentId: this.parentId ? this.parentId : 0,
          ChildId: this.deviationId,
          ModuleName: 'Deviation'
        };
        if (this.parentKey) {
          this.upConfig = {
            title: 'DEVIATION_DOCUMENT',
            titleAsLabel: true,
            editMode: true,
            windowedHeight: false,
            viewSwitch: false,
            showUserMeta: false,
            showSearchFilter: false,
            showUploadButton: true,
            showDeleteButton: true,
            uploaderUri: `${environment.BASE_URL}/${BaseServices.apiRoute(
              this.parentKey
            )}/file-upload`,
            addtionalData: this.additionalData
          };
        } else {
          this.upConfig = {
            title: 'DEVIATION_DOCUMENT',
            titleAsLabel: true,
            windowedHeight: false,
            viewSwitch: false,
            editMode: true,
            showUserMeta: false,
            showSearchFilter: false,
            showUploadButton: true,
            showDeleteButton: true,
            uploaderUri:
              environment.BASE_URL +
              '/file/upload/business/followup/deviation-docs',
            addtionalData: this.additionalData
          };
        }
        if (this.deviationId) {
          let deviationInfo = this.route.snapshot.data['edit'];

          if (BaseServices.UserRole === 'Guest') {
            this.disableSaveButton =
              BaseServices.UserId === deviationInfo.ExecutionUserId
                ? false
                : BaseServices.UserId === deviationInfo.FollowupUserId
                  ? false
                  : true;
          }
          if (BaseServices.UserRole === 'User') {
            this.onAdministrateDeviation();
          }
          deviationInfo.Status =
            deviationInfo.Status && deviationInfo.Status === 7
              ? 8
              : deviationInfo.Status;
          deviationInfo.Status = deviationInfo.Status?.toString();
          deviationInfo.department = deviationInfo.BIds;
          deviationInfo.Comment = deviationInfo.Comment;
          deviationInfo.Importance = deviationInfo.Importance;
          this.featureCompleteChecklistId =
            deviationInfo.FeatureCompleteChecklistId;
          this.executionId = deviationInfo.ExecutionUserId;
          this.followUpId = deviationInfo.FollowupUserId;
          this.featureKey = deviationInfo.FeatureId;
          this.featureId = deviationInfo.FeatureKey;
          this.featureManualChecklistId = deviationInfo.FeatureManualChecklistId
            ? deviationInfo.FeatureManualChecklistId
            : 0;
          this.appManualChecklistId = deviationInfo.AppManualChecklistId
            ? deviationInfo.AppManualChecklistId
            : 0;
          this.activityId = deviationInfo.ActivityId
            ? deviationInfo.ActivityId
            : 0;
          this.FeatureId = deviationInfo.FeatureKey
            ? deviationInfo.FeatureKey
            : 0;
          this.deviationNumber = deviationInfo.DeviationNumber;
          this.deviationNumberPrefix = deviationInfo.DeviationNumberPrefix;
          this.bindSubDepartmentDropdown(deviationInfo.department);
          if (deviationInfo.SubDepartmentId > 0) {
            this.IsSubDepartmentHidden = false;
          }
          this.initForm(deviationInfo);
          this.setModuleObjectDisplay(deviationInfo);
          if (
            (this.parentKey === 'FS' || this.parentKey == 'KC') &&
            deviationInfo.ObjectName !== null
          ) {
            this.isHideFS = false;
          } else {
            this.isHideFS = true;
          }
        }
      })
    );
    this.deviationLogData();
    if (
      BaseServices.UserId === this.followup &&
      (BaseServices.UserRole === 'User' || BaseServices.UserRole === 'Guest')
    ) {
      this.isShowDeviation = true;
      this.onAdministrateDeviation();
    }
    if (
      BaseServices.UserId === this.followUpId ||
      BaseServices.UserId === this.executionId
    ) {
      this.isShowDeviation = true;
    }
    if (+BaseServices.roleId === 2) {
      this.isGuestHideButton = false;
    }
    this.getBusinessDepartment();
  }

  initForm(data?: any) {
    let title = '';
    let department = '';
    let subDepartment = '';
    let Case = '';
    let topic = '';
    let importance = '';
    let cost = '';
    let deadline: any;
    let execution = '';
    let eventdate: any;
    let eventtime: any;
    let eventlocation = '';
    let description = '';
    let immediateAction = '';
    let analysis = '';
    let correctiveAction = '';
    let effectOfAction = '';
    let comment = '';
    let users = '';
    let status = '';
    // Numbers, not strings: the notification dropdowns' option values are numbers, and '0' matches none of them
    let beforedeadline: number | null = null;
    let beforefollowup = 0;
    let temperature: number | null = null;
    let objectName = '';
    let manual = '';
    this.createdByForSave = null;
    let reference = '';

    if (data) {
      this.Reference = data.Reference ? true : false;
      this.currentDeadLine = data.Deadline ? new Date(data.Deadline) : null;
      if (data.Status === 7) {
        this.isFollowup = false;
      }
      this.uploadedFiles = data.DeviationAttachment;

      deadline = data.Deadline ? new Date(data.Deadline) : null;
      // PrimeNG's datepicker blanks a value earlier than minDate, so an overdue deadline would look unset.
      // Lower minDate to the stored deadline so it is shown as saved; new deadlines still cannot be earlier.
      if (deadline && deadline < this.minDate) {
        this.minDate = new Date(deadline);
        this.minDate.setHours(0, 0, 0, 0);
      }

      title = data.Title;
      department = data.BIds;
      subDepartment = data.SubDepartmentId;
      topic = data.TopicId;
      importance = data.Importance;
      cost = data.Cost ? data.Cost : '0';
      eventdate = data.EventDate ? new Date(data.EventDate) : null;
      eventtime = HelperService.formatTime(
        data.EventTime ? data.EventTime : null
      );
      this.IsClear = eventdate !== null && eventtime !== null ? true : false;
      eventlocation = data.EventLocation;
      Case = data.CaseId;
      execution = data.ExecutionUserId;
      this.followup = data.FollowupUserId;
      description = data.Description;
      immediateAction = data.ImmediateAction;
      analysis = data.CauseAnalysis;
      correctiveAction = data.CorrectiveAction;
      effectOfAction = data.EffectOfAction;
      comment = data.Comment;
      temperature = parseTemperatureValue(data.TemperatureValue);
      // FeatureKey on this DTO holds Feature_Mapping.FeatureId - the module the deviation belongs to
      this.hasTemperature = isTemperatureControlFeature(data.FeatureKey);
      objectName = data.ObjectName;
      users = data.SendOnlyToEditors;
      status = data.Status === 7 ? 8 : data.Status;
      // Stream the "Deviation No" label so the title re-translates on language change.
      this.subscriptions.push(
        this.translate.stream('DEVIATIONNO').subscribe((devNoLabel: string) => {
          // Legacy rows can have no prefix - show the bare number instead of 'null-<number>'.
          const deviationNo = this.deviationNumberPrefix
            ? this.deviationNumberPrefix + '-' + this.deviationNumber
            : String(this.deviationNumber);
          this.PageTitle =
            data.Title + ' (' + devNoLabel + ': ' + deviationNo + ')';
        })
      );

      this.CreatedBy = data.CreatorName;
      this.CreatedOn = new Date(data.CreatedOn);
      this.time = new Date(data.CreatedOn).toLocaleTimeString();
      this.createdOnForSave = data.CreatedOn;
      this.createdByForSave = data.CreatedBy;
      beforedeadline = data.NotifyBeforeDeadLine ?? null;
      beforefollowup = data.NotificationBeforeFollowup ?? 0;
      manual = data.ManualId ? data.ManualId : '';
      reference = data.Reference ? data.Reference : null;

      // Debugging information
    }

    this.deviationEditForm = this.formBuilder.group({
      Title: new FormControl(title, [
        Validators.required,
        Validators.nullValidator
      ]),
      // Required for every module, food safety included - the API rejects a deviation without departments
      Department: new FormControl(department, [Validators.required]),
      SubDepartment: new FormControl(subDepartment),
      Topic: new FormControl(topic, [Validators.required]),
      Importance: new FormControl(importance, [Validators.required]),
      Cost: new FormControl(cost),
      Case: new FormControl(Case, [
        Validators.required,
        Validators.nullValidator
      ]),
      Execution: new FormControl(execution, [Validators.required]),
      Followup: new FormControl(this.followup, [Validators.required]),
      EventDate: new FormControl<Date | null>(eventdate),
      EventTime: new FormControl(eventtime),
      EventLocation: new FormControl(eventlocation),
      Description: new FormControl(description),
      ImmediateAction: new FormControl(immediateAction),
      Analysis: new FormControl(analysis),
      CorrectiveAction: new FormControl(correctiveAction),
      EffectOfAction: new FormControl(effectOfAction),
      Comment: new FormControl(comment),
      Reference: new FormControl(reference),
      days: this.formBuilder.group({
        Deadline: new FormControl<Date | null>(deadline, [
          Validators.required,
          Validators.nullValidator
        ]),
        Notification: new FormControl(
          beforedeadline,
          [ValidationService.nonNegativeValidator],
          control => this.notificationdays(control, data?.Deadline, data?.NotifyBeforeDeadLine)
        ),
        FollowupNotification: new FormControl(beforefollowup)
      }),
      Users: new FormControl(users),
      Status: new FormControl(status),
      Temperature: new FormControl<number | null>(temperature),
      ObjectName: new FormControl(objectName),
      Manual: new FormControl(manual)
    });

    // Explicitly set the Notification and FollowupNotification values after form initialization with a timeout
    setTimeout(() => {
      const notification = this.deviationEditForm
        .get('days')
        .get('Notification');
      notification.setValue(beforedeadline);
      // A stored notification can become invalid as the deadline approaches (e.g. 3 days before a deadline
      // tomorrow). Mark it touched so its error shows at once instead of Save being disabled with no message.
      notification.markAsTouched();
      this.deviationEditForm
        .get('days')
        .get('FollowupNotification')
        .setValue(beforefollowup);
      // A deviation that is already completed opens with the notification fields disabled and
      // the manage fields optional, the same as when the user selects Done - statusChange only
      // fires on interaction
      this.syncNotificationFields(+status);
      this.setManageFieldsRequired(+status !== Status.Done);
    }, 0);
  }

  routePath() {
    this.parentPath = this.route.snapshot.parent.parent.routeConfig['path'];
    if (this.parentPath === 'follow-up') {
      this.isFollowup = true;
    } else {
      this.isFollowup = false;
    }
  }
  //#endregion
  //#region page-event

  //#endregion
  /**
   * cost key press event
   * @param e {e}
   * @param limitNumber {limitNumber}
   */
  onNumber(e: any, limitNumber: any) {
    const limit = limitNumber;
    const dots = e.target.value.indexOf('.');
    let charCode = e.which ? e.which : e.keyCode;
    if (
      e.target.value.length === limit ||
      dots > 1 ||
      (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)
    ) {
      e.preventDefault();
    }
  }
  /**
   * file upload events
   * @param event {any}
   */
  saveUploaded(event: any) {
    if (event) {
      let eventType = event.eventName;
      let keyBindings = {
        Originalname: 'OriginalFileName',
        FileTypeId: 'FileType'
      };
      let deviationDoc = Object.assign({}, event, this.additionalData);
      switch (eventType) {
        case 'DeleteDefaultFile':
          this.uploadedFiles = this.uploadedFiles.filter(
            (x: any) => x.path !== event.item.data.path
          );
          if (event.item.data.id === 0) {
            this.newDocumentAdded = this.newDocumentAdded.filter(
              (x: any) => x.Path !== event.item.data.path
            );
          } else {
            //  remove existing attachement
            this.subscriptions.push(
              this.deviationService
                .deleteDeviationAttachment(event.item.data.id)
                .subscribe((result: any) => {
                  if (result) {
                    // remove from display list
                    this.uploadedFiles = this.uploadedFiles.filter(
                      (x: any) => x.path !== event.item.data.path
                    );
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  }
                })
            );
          }
          break;
        default:
          deviationDoc.id = 0;
          deviationDoc.createdBy = BaseServices.UserId;
          deviationDoc.status = 1;
          this.newDocumentAdded.push(
            HelperService.switchKeysCase(deviationDoc, keyBindings)
          );
          break;
      }
    }
  }

  /**
   * sava case dropdown
   */
  saveCase() {
    this.isExistCaseText = this.translate.instant('TOPIC_EXIST');
    let casetype = new deviationCaseType();
    casetype.Id = this.caseId ? this.caseId : 0;
    casetype.Name = this.selectedCaseType.Name;
    casetype.BusinessId = this.effectiveBusinessId;
    casetype.ApplicationId = BaseServices.ApplicationId;
    casetype.Status = '1';
    if (casetype.Id > 0) {
      this.subscriptions.push(
        this.deviationService
          .updateCaseType(casetype)
          .subscribe((updateCaseType: any) => {
            if (updateCaseType) {
              this.isCaseDialog = false;
              this.bindCaseDropdown();
              this.deviationEditForm.get('Case').patchValue(updateCaseType.Id);
              this.selectedCaseType = new deviationCaseType();
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.caseId = 0;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService
          .checkTypecaseExist(casetype.Name)
          .subscribe((result: any) => {
            if (result.Isavailable === true) {
              this.isLabelDisabled = true;
            } else {
              this.isCaseDialog = false;
              this.subscriptions.push(
                this.deviationService
                  .createCaseType(casetype)
                  .subscribe((caseType: any) => {
                    if (caseType) {
                      this.bindCaseDropdown();
                      this.deviationEditForm
                        .get('Case')
                        .patchValue(caseType.Id);
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    }
                  })
              );
            }
          })
      );
    }
    this.clearCase();
  }

  viewCaseType() {
    this.isLabelDisabled = false;
  }

  /**
   * clear popup value
   */
  clearCase() {
    this.caseForm = this.formBuilder.group({
      Name: ['']
    });
  }
  /**
   * save topic
   */
  saveTopic() {
    this.AddTopicLoading = true;
    let topic = new Topic();
    topic.Id = this.topicId ? this.topicId : 0;
    topic.Name = this.TopicForm.value.Topic;
    topic.Status = '1';
    topic.BusinessId = this.effectiveBusinessId;
    if (this.topicId > 0) {
      this.subscriptions.push(
        this.deviationService
          .updateTopics(topic)
          .subscribe((isTopicUpdated: any) => {
            if (isTopicUpdated) {
              this.isAddTopic = false;
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.AddTopicLoading = false;
              this.fetchTopic();
              this.deviationEditForm.get('Topic').patchValue(isTopicUpdated.Id);
              this.topicId = 0;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService
          .checkTopicExist(topic.Name)
          .subscribe((result: any) => {
            if (result.Isavailable === true) {
              this.isTopicalertDisabled = true;
            } else {
              this.isAddTopic = false;
              this.subscriptions.push(
                this.deviationService
                  .addTopics(topic)
                  .subscribe((isAddTopics: any) => {
                    if (isAddTopics) {
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      this.AddTopicLoading = false;
                      this.fetchTopic();
                      this.deviationEditForm
                        .get('Topic')
                        .patchValue(isAddTopics.Id);
                    }
                  })
              );
            }
          })
      );
    }
  }
  /**
   * update deviation list
   */
  updateChanges() {
    this.loading = true;
    let windowOrigin = window.location.origin;
    let applicationBase = '';
    let appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
    if (appSettings) {
      applicationBase = appSettings.BaseUrl;
    }
    let url =
      windowOrigin +
      '/' +
      applicationBase +
      '/login?returnUrl=' +
      '/app/business/' +
      this.effectiveBusinessId +
      '/follow-up/deviations/edit/';
    if (
      this.deviationEditForm.valid ||
      this.deviationEditForm.value.Status === '10'
    ) {
      this.manualID = this.deviationEditForm.value.Manual
        ? this.deviationEditForm.value.Manual
        : 0;

      const status = +this.deviationEditForm.value.Status;
      const request: UpdateDeviationRequestDto = {
        Title: this.deviationEditForm.value.Title,
        BusinessDepartmentIds: this.deviationEditForm.value.Department,
        TopicId: this.deviationEditForm.value.Topic,
        CaseId: this.deviationEditForm.value.Case,
        Status: status,
        SubDepartmentId: this.deviationEditForm.value.SubDepartment,
        Description: this.deviationEditForm.value.Description,
        EventDate: this.deviationEditForm.value.EventDate
          ? this.dateService.formatDateToString(
              this.deviationEditForm.value.EventDate
            )
          : undefined,
        EventTime: this.deviationEditForm.value.EventTime
          ? HelperService.formatTime(this.deviationEditForm.value.EventTime)
          : undefined,
        EventLocation: this.deviationEditForm.value.EventLocation,
        ImmediateAction: this.deviationEditForm.value.ImmediateAction,
        Deadline: this.deviationEditForm.value.days.Deadline
          ? this.dateService.formatDateToString(
              this.deviationEditForm.value.days.Deadline
            )
          : undefined,
        Importance: this.deviationEditForm.value.Importance,
        Cost: this.deviationEditForm.value.Cost,
        CauseAnalysis: this.deviationEditForm.value.Analysis,
        CorrectiveAction: this.deviationEditForm.value.CorrectiveAction,
        EffectOfAction: this.deviationEditForm.value.EffectOfAction,
        Comment: this.deviationEditForm.value.Comment,
        ExecutionUserId: this.deviationEditForm.value.Execution,
        NotifyBeforeDeadLine: this.deviationEditForm.value.days.Notification,
        FollowupUserId: this.deviationEditForm.value.Followup,
        NotificationBeforeFollowup:
          this.deviationEditForm.value.days.FollowupNotification,
        // Null clears the temperature; the backend ignores it for modules without the field
        Temperature: this.hasTemperature
          ? (this.deviationEditForm.value.Temperature ?? null)
          : undefined,
        DeviationAttachments: (this.newDocumentAdded ?? []).map(
          (a: any): DeviationAttachmentRequest => ({
            Id: 0,
            Filename: a.Filename,
            OriginalFileName: a.OriginalFileName,
            MimeType: a.MimeType,
            Size: a.Size,
            Path: a.Path,
            FileType: a.FileType,
            Status: a.Status
          })
        )
      };

      this.subscriptions.push(
        this.deviationService
          .updateDeviationV2(this.deviationId, request)
          .subscribe(() => {
            if (status === Status.Done && this.manualID != 0) {
              this.notifications.success('REPORT_UPLOADED_FOODSAFETY');
            }
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.gotoList();
          })
      );
    }
  }

  /**
   * topic dropdown change eventF
   * @param e
   * @param topicDropdown
   */

  onTopicChanged(e: any, topic: any) {
    if (e.value) {
      this.topicLabel = topic.selectedOption.label;
    }
  }

  /**
   * department dropdown change eventF
   * @param e
   * @param departmentDropdown
   */
  onDepartmentChanged(e: any, department: any) {
    this.bindSubDepartmentDropdown(department.value);
  }

  /**
   * case dropdown change eventF
   * @param e
   * @param caseDropdown
   */
  onCaseChanged(e: any, casename: any) {
    if (e.value) {
      this.caseLabel = casename.selectedOption.label;
    }
  }

  /**
   * importance dropdown change eventF
   * @param e
   * @param importanceDropdown
   */

  onImportanceChanged(e: any, importance: any) {
    if (e.value) {
      this.importanceLabel = importance.selectedOption.label;
    }
  }

  /**
   * execution dropdown change eventF
   * @param e
   * @param executionDropdown
   */

  onExecChanged(e: any, exec: any) {
    if (e.value) {
      this.execLabel = exec.selectedOption.label;
    }
  }

  /**
   * followup dropdown change event
   * @param e
   * @param followupDropdown
   */

  onFollowChanged(e: any, follow: any) {
    if (e.value) {
      this.followLabel = follow.selectedOption.label;
    }
  }

  /**
   * print this page event
   */
  exportPdf() {
    let deviation = new DeviationShared();
    deviation.DeviationNumber = this.deviationNumber;
    deviation.DeviationNumberPrefix = this.deviationNumberPrefix;
    deviation.BusinessDepartmentId = this.deviationEditForm.value.Department;
    deviation.BusinessId = this.effectiveBusinessId;
    deviation.TopicId = this.deviationEditForm.value.Topic;
    deviation.TopicLabel = this.topicLabel;
    deviation.DepartmentLabel = this.departmentsLabel;
    deviation.CaseLabel = this.caseLabel;
    deviation.ImportanceLabel = this.importanceLabel;
    deviation.ExecLabel = this.execLabel;
    deviation.FollowLabel = this.followLabel;
    deviation.Title = this.deviationEditForm.value.Title;
    deviation.Importance = this.deviationEditForm.value.Importance;
    const eventDate = this.deviationEditForm.value.EventDate as Date;
    deviation.EventDate = eventDate
      ? new Intl.DateTimeFormat('en-US').format(eventDate)
      : '';

    deviation.EventTime = this.deviationEditForm.value.EventTime
      ? HelperService.formatTime(this.deviationEditForm.value.EventTime)
      : null;

    deviation.EventLocation = this.deviationEditForm.value.EventLocation;
    deviation.Cost = this.deviationEditForm.value.Cost;
    deviation.Deadline = this.deviationEditForm.value.days.Deadline
      ? this.dateService.formatDateToString(
          this.deviationEditForm.value.days.Deadline
        )
      : '';

    deviation.CaseId = this.deviationEditForm.value.Case;
    deviation.Comment = this.deviationEditForm.value.Comment;
    deviation.ExecutionUserId = this.deviationEditForm.value.Execution;
    deviation.FollowupUserId = this.deviationEditForm.value.Followup;
    deviation.Description = this.deviationEditForm.value.Description;
    deviation.ImmediateAction = this.deviationEditForm.value.ImmediateAction;
    deviation.CauseAnalysis = this.deviationEditForm.value.Analysis;
    deviation.CorrectiveAction = this.deviationEditForm.value.CorrectiveAction;
    deviation.EffectOfAction = this.deviationEditForm.value.EffectOfAction;
    deviation.CreatedOn = this.createdOnForSave;

    deviation.CreatedBy = BaseServices.UserId;
    deviation.NotifyBeforeDeadLine =
      this.deviationEditForm.value.days.Notification;
    deviation.NotificationBeforeFollowup =
      this.deviationEditForm.value.days.FollowupNotification;
    deviation.IsShowtoUsers = this.deviationEditForm.value.Users;
    deviation.Status = this.deviationEditForm.value.Status;
    deviation.ApplicationId = BaseServices.ApplicationId;

    if (deviation.Status === '9') {
      deviation.CompletedDate = HelperService.formatDate(new Date());
    }

    deviation.ModifiedBy = BaseServices.UserId;
    deviation.Reference = this.deviationEditForm.value.Reference;
    deviation.DeviationAttachment = this.newDocumentAdded;

    this.loadingReport = true;
    let fileName = this.translate.instant('DEVIATION_DETAILS');
    let filetype = 'pdf';
    let position = 0;
    let cultureInfo = sessionStorage.getItem('languageMode');
    let ReportJson = this.route.snapshot.data['edit'];
    let FeatureId = ReportJson.FeatureKey;
    let projectId = this.route.snapshot.params['deviationId'];

    this.subscriptions.push(
      this.deviationService
        .deviationReportGenerate(
          projectId,
          this.effectiveBusinessId,
          this.deviationId,
          cultureInfo,
          deviation,
          FeatureId,
          BaseServices.UserId
        )
        .subscribe(
          blob => {
            this.loadingReport = false;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${fileName}.${filetype.toLowerCase()}`;
            link.click();
          },
          error => {
            this.loadingReport = false;
            
          }
        )
    );
  }
  //#endregion
  onDeadLineChanged(event: Date | any) {
    // Handle both Date objects from p-calendar and legacy IMyDateModel format
    if (event instanceof Date) {
      this.currentDeadLine = new Date(event.getTime());
    } else if (event?.jsdate) {
      this.currentDeadLine = new Date(event.jsdate.getTime());
    } else {
      this.currentDeadLine = null;
    }
    this.currentDate = new Date();
    this.deviationEditForm['controls'].days['controls'].Notification.setValue(
      0
    );
  }
  /** Validate changed reminders while preserving historical settings on unrelated edits. */
  notificationdays(
    control: AbstractControl,
    originalDeadline?: string | Date,
    originalNotification?: number | null
  ) {
    const deadline = this.currentDeadLine;
    if (control.value == null || !deadline) {
      return Promise.resolve(null);
    }
    const dateOnly = (date: Date) =>
      new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    if (
      originalDeadline &&
      dateOnly(deadline) === dateOnly(new Date(originalDeadline)) &&
      control.value === originalNotification
    ) {
      return Promise.resolve(null);
    }
    const daysUntilDeadline = Math.round(
      (dateOnly(deadline) - dateOnly(new Date())) / (1000 * 60 * 60 * 24)
    );
    return Promise.resolve(
      control.value > daysUntilDeadline ? { notificationdays: true } : null
    );
  }

  /**
   * binding dropdowns
   */
  bindFormDropdowns() {
    this.followUpNotify = [];
    for (let n = 0; n <= 14; n++) {
      if (n === 0) {
        this.followUpNotify.push({
          label: this.translate.instant('ON_DEADLINE_DATE'),
          value: n
        });
      } else {
        this.followUpNotify.push({ label: n.toString(), value: n });
      }
    }
    this.followUpNotify.push(
      { label: this.translate.instant('TREE_WEEKS'), value: 21 },
      { label: this.translate.instant('ONE_MONTH'), value: 30 }
    );

    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 1 },
          { label: val.MEDIUM, value: 2 },
          { label: val.HIGH, value: 3 }
        );
      })
    );

    let topics = this.route.snapshot.data['topic'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.topics = [];
        this.topics.push({ label: val.SELECT, value: null });
        if (topics) {
          topics.forEach((topicList: any) => {
            this.topics.push({
              label: topicList.Name,
              value: topicList.Id
            });
            this.topicList.push({ Name: topicList.Name, Id: topicList.Id });
          });
        }
      })
    );

    this.departments = [];
    let roleId = BaseServices.roleId;
    if (roleId === '1' || roleId === '2' || !this.portalBusinessId) {
      this.departmentList = this.route.snapshot.data['adminDepartment'];
    } else {
      this.departmentList = this.route.snapshot.data['department'];
    }
    let department = _.filter(this.departmentList, {
      ParentId: null
    });
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.departments = [];
        this.departments.push({ label: val.SELECT, value: null });
        if (department) {
          department.forEach((department: any) => {
            if (department.Id) {
              let subDepartment = _.filter(this.departmentList, {
                ParentId: department.Id
              });
              this.departments.push({
                label: department.Name,
                value: department.Id
              });
              if (subDepartment.length > 0) {
                subDepartment.forEach((subDept: any) => {
                  this.departments.push({
                    label: `${department.Name} (${subDept.Name})`,
                    value: department.Id
                  });
                });
                this.IsSubDepartmentHidden = false;
              }
            }
          });
        }
      })
    );

    let responsiblePerson = this.route.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.executions = [];
        this.executions.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.executions.push({
              label: followupExecution.Name,
              value: this.isPortal
                ? followupExecution.ContactPersonId
                : followupExecution.Id
            });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.followUps = [];
        this.followUps.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.followUps.push({
              label: followupExecution.Name,
              value: this.isPortal
                ? followupExecution.ContactPersonId
                : followupExecution.Id
            });
          });
        }
      })
    );
    this.followUpAssignedUsers = [];
    if (this.parentPath === 'follow-up' && !this.portalBusinessId) {
      // Only make the API call if we have a valid FeatureKey (not null/undefined)
      const featureKey = BaseServices.FeatureKey;
      if (featureKey != null) {
        this.subscriptions.push(
          this.deviationService
            .getResponsibleAndAssignedUsersForFollowup(
              this.effectiveBusinessId,
              BaseServices.FeatureId,
              featureKey
            )
            .subscribe((result: any) => {
              if (result) {
                result.forEach(element => {
                  this.followUpAssignedUsers.push({
                    label: element.Name,
                    value: element.Id
                  });
                });
                this.executions.push(...this.followUpAssignedUsers);
                this.followUps.push(...this.followUpAssignedUsers);
              }
            })
        );
      }
    }
    let typeOfCases = this.route.snapshot.data['caseType'];
    if (typeOfCases) {
      this.editTypes = [];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.cases = [];
          this.cases.push({ label: val.SELECT, value: null });
          typeOfCases.forEach((caseList: any) => {
            this.cases.push({ label: caseList.Name, value: caseList.Id });
            this.editTypes.push({ Name: caseList.Name, Id: caseList.Id });
          });
        })
      );
    }
    let deviationInfo = this.route.snapshot.data['edit'];
    if (deviationInfo) {
      this.deviationFeatureKey = deviationInfo.FeatureKey;
    }
    if (this.deviationFeatureKey === Module.FOLLOWUPS) {
      let currentUserRole = BaseServices.UserRole;
      let manualRightsId = Rights.VIEW_MANUALS;
      this.isShowManualList = true;
      this.BusinessId = deviationInfo.BusinessId;
      this.bindManualDropdown(this.BusinessId);
    } else {
      this.isShowManualList = false;
    }
  }

  bindManualDropdown(BusinessId: number) {
    this.subscriptions.push(
      this.deviationService
        .getAssignedBusinessManual(+BusinessId)
        .subscribe(response => {
          if (response) {
            this.subscriptions.push(
              this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                this.manualListItems = [];
                this.manualListItems.push({ label: val.SELECT, value: null });
              })
            );
            response.forEach((manualData: any) => {
              this.manualListItems.push({
                label: manualData.Title,
                value: manualData.Id
              });
            });
          }
        })
    );
  }

  /**
   * bind type case dropdown
   */
  bindCaseDropdown() {
    this.subscriptions.push(
      this.deviationService.getAllCaseType().subscribe((caseType: any) => {
        if (caseType) {
          this.subscriptions.push(
            this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
              this.cases = [];
              this.cases.push({ label: val.SELECT, value: null });
            })
          );
          caseType.forEach((caseList: any) => {
            this.cases.push({
              label: caseList.Name,
              value: caseList.Id
            });
          });
          this.editTypes = caseType;
        }
      })
    );
  }

  /**
   * edit case type
   * @param casetype {any}
   */
  editCase(casetype: any) {
    this.selectedCaseType = casetype;
    this.caseId = this.selectedCaseType.Id;
  }

  /**
   * display case dropdown
   */
  showCase() {
    this.isCaseDialog = true;
  }
  /**
   * display topic dialog
   */
  showTopic() {
    this.isAddTopic = true;
  }
  /**
   * delete case dropdown item
   * @param selectedCaseType
   */
  deleteCase(selectedCaseType: any) {
    this.subscriptions.push(
      this.deviationService
        .checkExistingTypeForDelete(selectedCaseType)
        .subscribe((inUse: any) => {
          if (inUse) {
            this.notifications.warn('YOU_CANNOT_DELETE_CASE_USED_BY_ANOTHER_DEVIATION');
            return;
          }
          this.confirmationService.confirm({
            message: this.translate.instant('DELETE_THIS_RECORD'),
            accept: () => {
              this.subscriptions.push(
                this.deviationService
                  .deleteType(selectedCaseType)
                  .subscribe(isCaseDeleted => {
                    if (isCaseDeleted) {
                      this.bindCaseDropdown();
                      this.notifications.success('UI_NOTIFICATIONS.DELETED');
                    }
                  })
              );
            }
          });
        })
    );
  }
  /**
   * Fetch the topics
   */
  fetchTopic() {
    this.subscriptions.push(
      this.deviationService
        .getAllTopics(this.effectiveBusinessId)
        .subscribe((topic: any) => {
          this.subscriptions.push(
            this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
              this.topics = [];
              this.topics.push({ label: val.SELECT, value: null });
              if (topic) {
                topic.forEach((topics: any) => {
                  if (topics) {
                    this.topics.push({
                      label: topics.Name,
                      value: topics.Id
                    });
                  }
                });
                this.topicList = topic;
              }
            })
          );
        })
    );
  }
  /**
   * edit topic
   * @param Topic {any}
   */
  editTopic(topic: Topic) {
    this.topicId = topic.Id;
    let topicName = {
      Topic: topic.Name
    };
    (<FormGroup>this.TopicForm).setValue(topicName, { onlySelf: true });
  }
  clear() {
    this.TopicForm = this.formBuilder.group({
      Topic: ''
    });
  }

  /**
   * delete type of topic
   * @param deleteTopic {any}
   */
  deleteTopic(deleteTopic: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService
            .deleteTopics(deleteTopic)
            .subscribe((topic: any) => {
              if (topic) {
                this.fetchTopic();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }
  /**
   * getting and listing deviation log grid values
   */
  deviationLogData() {
    this.subscriptions.push(
      this.deviationService
        .getDeviationLog(this.deviationId)
        .subscribe((deviationLog: any) => {
          if (deviationLog) {
            deviationLog.forEach((log: any) => {
              if (log.ColumnName === 'Importance') {
                log.OldValue = this.assignRiskData(log.OldValue);
                deviationLog.OldValue = log.OldValue;
              } else if (log.ColumnName === 'Status') {
                log.OldValue = this.assignStatus(log.OldValue);
                deviationLog.OldValue = log.OldValue;
              }
            });
            this.deviationLog = deviationLog;
          }
        })
    );
  }
  assignStatus(status: string) {
    let statusText: string;
    if (status) {
      switch (status) {
        case '7':
          statusText = 'New';
          break;
        case '8':
          statusText = 'Open';
          break;
        case '9':
          statusText = 'Done';
          break;
        case '10':
          statusText = 'Rejected';
          break;
        default:
          statusText = status;
      }
    }
    return statusText;
  }
  assignRiskData(importance: any) {
    let impData: any = [];
    if (importance) {
      switch (importance) {
        case '1':
          impData = 'Low';
          break;
        case '2':
          impData = 'Medium';
          break;
        case '3':
          impData = 'High';
          break;
      }
    }
    return impData;
  }
  /**
   * display department dropdown
   */
  showDepartment() {
    this.department = true;
  }

  /**
   * go back to list
   */
  gotoList() {
    this.location.back();
  }
  /**
   * close popup
   */
  /**
   * get department values for edit
   * @param deptdetails
   */
  editDepartment(deptdetails: any) {
    this.deptId = this.selectedDepartment.Id;
    this.selectedDepartment = deptdetails;
    this.getBusinessDepartment();
  }

  onBeforeCaseDialogHide() {
    this.isLabelDisabled = false;
    this.caseForm.reset();
    this.hidingElement = false;
    this.caseForm.reset();
    this.hidesElement = false;
    this.isDepartmentErrorDisabled = false;
  }
  /**
     /**
   * close popup
   */
  onBeforeTopicDialogHide() {
    this.isTopicalertDisabled = false;
    this.TopicForm.reset();
    this.viewTopic = false;
  }
  /**
   * get current date
   */
  getCurrentDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() - 1
    };
  }
  /**
   * update deviation based on viewdeviation rights
   */
  onViewDeviation() {
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.VIEW_DEVIATION;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      this.canShowDeviation = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      if (this.canShowDeviation) {
        this.isShowDeviation = false;
      }
    }
  }
  statusChange(event: any, option: any) {
    if (option && this.deviationFeatureKey === Module.FOLLOWUPS) {
      this.isShowManualList = option.id === 9 ? true : false;
      if (this.isShowManualList) {
        this.bindManualDropdown(this.BusinessId);
      }
    }
    this.isShowNotification =
      option.id === 9 || option.id === 10 ? false : true;
    this.syncNotificationFields(option.id);
    this.setManageFieldsRequired(option.id !== Status.Done);
  }

  /**
   * Deadline, Importance, Execution and Followup are required on an open deviation, because that
   * is what makes it possible to act on and to remind someone about. A completed one records how
   * it was handled rather than who will handle it, and has no reminder a missing responsible user
   * could break - so there the same four are optional. The backend applies the same exception.
   */
  private setManageFieldsRequired(required: boolean) {
    const controls = [
      this.deviationEditForm.get('Importance'),
      this.deviationEditForm.get('Execution'),
      this.deviationEditForm.get('Followup'),
      this.deviationEditForm.get('days')?.get('Deadline')
    ];

    for (const control of controls) {
      if (!control) {
        continue;
      }
      if (required) {
        control.setValidators([Validators.required, Validators.nullValidator]);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  /**
   * A completed deviation has nothing left to remind anyone about, so both notification fields
   * are disabled. A disabled control drops out of `form.value`, which is what clears the stored
   * days - leaving them would keep a reminder that can never be sent, and the backend rejects
   * the combination outright.
   */
  private syncNotificationFields(status: number) {
    const days = this.deviationEditForm.get('days');
    const notification = days?.get('Notification');
    const followupNotification = days?.get('FollowupNotification');

    if (status === Status.Done) {
      notification?.reset();
      notification?.disable();
      followupNotification?.reset();
      followupNotification?.disable();
    } else {
      notification?.enable();
      followupNotification?.enable();
    }
  }
  /**
   * Edit the page based upon administrate deviation rights
   */
  onAdministrateDeviation() {
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    let userId = BaseServices.UserId;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      if (userId === this.followUpId || userId === this.executionId) {
        this.isShowDeviation = true;
      } else {
        this.isShowDeviation = BaseServices.checkUserRights(
          userRightsId,
          currentUserRole
        );
        if (this.isShowDeviation === false) {
          this.onViewDeviation();
        }
      }
    }
    this.upConfig.showDeleteButton = this.isShowDeviation;
  }
  //#endregion

  /**
   * get selected manual id
   */
  manualChangeItem(event: any) {
    this.manualID = event.value;
  }

  /**
   * get current date
   */
  getCurrentEventDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() + 1
    };
  }

  /**
   * bind evnet date and time
   */
  bindEventDate() {
    let dateFormat = new Date();
    this.deviationEditForm.get('EventDate')?.setValue(new Date());
    this.deviationEditForm
      .get('EventTime')
      ?.setValue(this.datePipe.transform(dateFormat, 'HH:mm'));
    this.IsClear = true;
  }

  /**
   * clear evnet date and time
   */
  clearEventDate() {
    this.deviationEditForm.controls['EventDate'].setValue(null);
    this.deviationEditForm.controls['EventTime'].setValue(null);
    this.IsClear = false;
  }

  /**
   * enable clear button
   */
  enableClear() {
    this.IsClear = true;
  }

  /**
   * get all department dropdown list
   */
  getBusinessDepartment() {
    this.isDepartmentErrorDisabled = false;
    this.departmentdetails = []; // Clear the array before loading new data
    if (this.portalBusinessId) {
      this.subscriptions.push(
        this.businessDepartmentService
          .getDepartmentsByBusinessId(this.portalBusinessId)
          .subscribe((department: any[]) => {
            if (department) {
              // Use first() to prevent multiple subscriptions when language changes
              this.translate
                .stream('SELECT_DROPDOWN')
                .pipe(first())
                .subscribe(val => {
                  this.Department = [];
                  this.departments = [];
                  this.Department.push({ label: val.SELECT, value: null });
                  if (department) {
                    department.forEach((caseValue: any) => {
                      this.Department.push({
                        label: caseValue.Name,
                        value: caseValue.Id
                      });
                      this.departments.push({
                        label: caseValue.Name,
                        value: caseValue.Id
                      });
                    });
                  }
                });
              this.departmentdetails = department;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.businessDepartmentService
          .getCachedBusinessDepartment()
          .subscribe(department => {
            if (department) {
              this.subscriptions.push(
                this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                  this.Department = [];
                  this.departments = [];
                  this.Department.push({ label: val.SELECT, value: null });
                  if (department) {
                    department.forEach((caseValue: any) => {
                      this.Department.push({
                        label: caseValue.Name,
                        value: caseValue.Id
                      });
                      this.departments.push({
                        label: caseValue.Name,
                        value: caseValue.Id
                      });
                    });
                  }
                })
              );
              this.departmentdetails = department;
            }
          })
      );
    }
  }

  /**
   * save department dropdown
   */
  saveDepartment() {
    let deptdetails = new Department();
    deptdetails.BusinessId = this.effectiveBusinessId;
    deptdetails.ApplicationId = BaseServices.ApplicationId;
    deptdetails.Id = this.deptId ? this.deptId : 0;
    deptdetails.Name = this.selectedDepartment.Name;
    deptdetails.Status = '1';
    if (deptdetails.Id > 0) {
      deptdetails.ModifiedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .updateDepartment(deptdetails)
          .subscribe((department: any) => {
            if (department) {
              this.clearCachedDepartment();
              this.department = false;
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.getBusinessDepartment();
              this.deptId = 0;
            }
          })
      );
    } else {
      this.clearCachedDepartment();
      deptdetails.Id = 0;
      deptdetails.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .checkDepartmentExist(deptdetails.Name)
          .subscribe((result: any) => {
            if (result.Isavailable === true) {
              this.isDepartmentErrorDisabled = true;
            } else {
              this.subscriptions.push(
                this.deviationService
                  .addDepartment(deptdetails)
                  .subscribe((department: any) => {
                    if (department) {
                      this.department = false;
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      this.getBusinessDepartment();
                    }
                  })
              );
            }
          })
      );
    }
    this.clearDepartment();
  }
  /**
   * clear popup value
   */
  clearDepartment() {
    this.selectedDepartment.Id = 0;
    this.departmentForm = this.formBuilder.group({
      Name: ['']
    });
  }
  /**
   * cache clear of department
   */
  clearCachedDepartment() {
    this.businessDepartmentService.clearCachedAllDepartment();
  }
  /**
   * Check if user can delete department based on role and BusinessId
   * @param department Department to check
   * @returns boolean indicating if deletion is allowed
   */
  canDeleteDepartment(department: Department): boolean {
    const roleId = +BaseServices.roleId;
    const restrictedRoles = [3, 4, 5]; // Editor, Guest, User

    // If BusinessId is 0 and user has restricted role, cannot delete
    if (department.BusinessId === 0 && restrictedRoles.includes(roleId)) {
      return false;
    }
    return true;
  }

  /**
   * department dropdown delete
   * @param selectedDepartment
   */
  deleteDepartment(selectedDepartment: Department) {
    // Check if user has permission to delete this department
    if (!this.canDeleteDepartment(selectedDepartment)) {
      this.notifications.add({ severity: 'error', summary: this.translate.instant('NO_PERMISSION'), detail: this.translate.instant('NO_PERMISSION_TO_DELETE_THIS_DEPARTMENT') });
      return;
    }

    this.subscriptions.push(
      this.deviationService
        .checkDepartmentExist(selectedDepartment.Name)
        .subscribe(() => {
          this.confirmationService.confirm({
            message: this.translate.instant('DELETE_THIS_RECORD'),
            accept: () => {
              this.subscriptions.push(
                this.deviationService
                  .deleteDepartment(selectedDepartment.Id)
                  .subscribe(result => {
                    if (result) {
                      this.departments = this.departments.filter(
                        department => department.value !== selectedDepartment.Id
                      );
                      this.getBusinessDepartment();
                      this.notifications.success('UI_NOTIFICATIONS.DELETED');
                    }
                  })
              );
            }
          });
        })
    );
    this.getBusinessDepartment();
  }

  toggleDeviationLog() {
    this.showDeviationLog = !this.showDeviationLog;
  }

  /**
   * Bind sub department dropdown
   */
  bindSubDepartmentDropdown(departmentIds?: number[]) {
    if (!departmentIds || departmentIds.length === 0) {
      return;
    }
    this.subscriptions.push(
      this.employeeServices
        .getAllSubDepartments(departmentIds)
        .subscribe((subDepartment: any) => {
          this.subDepartmentsList = [];
          this.subDepartmentsList.push({
            label: this.translate.instant('SELECT'),
            value: null
          });
          subDepartment.forEach((element: any) => {
            if (subDepartment) {
              this.subDepartmentsList.push({
                label: element.Name,
                value: element.Id
              });
            }
            this.editSubDepartments = subDepartment;
          });
          this.IsSubDepartmentHidden = subDepartment.length > 0 ? false : true;
        })
    );
  }

  /**
   * Creates and opens the Add Sub Department modal dynamically
   */
  addSubDepartment() {
    const modalComponentRef = this.addSubDeptModalContainer.createComponent(
      AddDeviationComponent
    );
    this.addSubDeptComponentRef = modalComponentRef;
    modalComponentRef.setInput('isEditSubDept', true);
    modalComponentRef.setInput(
      'departmentIdList',
      this.deviationEditForm.value.Department
    );
    modalComponentRef.instance.subDepModalClosed.subscribe(() => {
      this.closeModal();
    });
  }
  /**
   * Lets the temperature field accept both "," and "." as the decimal separator
   */
  onTemperatureKeyDown(event: KeyboardEvent, input: InputNumber): void {
    acceptBothDecimalSeparators(event, input);
  }

  /**
   * Destroys the dynamically created Add Sub Department modal and clears the reference
   */
  closeModal(): void {
    if (this.addSubDeptComponentRef) {
      this.addSubDeptComponentRef.destroy();
      this.addSubDeptComponentRef = null;
    }
  }
  /**
   * Builds the read-only "Module - Object name" text shown below Status (#5749).
   * FS/KC deviations already carry ObjectName in the payload; for the others the
   * object name is resolved from the module-objects list by FeatureId + FeatureKey.
   * @param data resolved deviation edit payload
   */
  private setModuleObjectDisplay(data: any) {
    const objectName = data && data.ObjectName ? data.ObjectName : '';
    if (!objectName) {
      this.moduleObjectDisplay = '';
      return;
    }
    // The edit payload carries the module id in FeatureKey. Stream the module
    // label so it re-translates when the language changes (#5749).
    const moduleKey = this.getModuleTranslateKey(data ? data.FeatureKey : null);
    if (!moduleKey) {
      this.moduleObjectDisplay = objectName;
      return;
    }
    this.subscriptions.push(
      this.translate.stream(moduleKey).subscribe((moduleName: string) => {
        this.moduleObjectDisplay =
          (moduleName ? moduleName + ' - ' : '') + objectName;
      })
    );
  }

  /**
   * Maps a module feature id to its translation key. Returns '' when unmapped. #5749
   */
  private getModuleTranslateKey(featureId: number): string {
    const keyByFeatureId: { [id: number]: string } = {
      [Module.PROJECT]: 'PROJECT',
      [Module.FOODSAFETY]: 'FOOD_SAFETY',
      [Module.FIREDEVIATION]: 'FDV',
      [Module.INTERNALCONTROL]: 'INTERNAL_CONTROL',
      [Module.OTHER_SYSTEMS]: 'OTHER_SYSTEMS',
      [Module.KUBA_CONTROL]: 'KUBA_CONTROL',
      [Module.VEHICLE]: 'VEHICLES',
      [Module.QUALITY_SYSTEMS]: 'QUALITY_SYSTEMS',
      230: 'FLEXI_SAFETY_ROUNDS.MODULE'
    };
    return featureId ? keyByFeatureId[featureId] || '' : '';
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
